import { Facebook, Instagram, Linkedin } from 'lucide-react';

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Hendro Wijaya',
      position: 'CEO & Founder',
      image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Berpengalaman lebih dari 15 tahun dalam industri ketenagakerjaan dengan visi memajukan kualitas SDM Indonesia.',
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 2,
      name: 'Anita Susanti',
      position: 'COO',
      image: 'https://images.pexels.com/photos/3796217/pexels-photo-3796217.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Ahli dalam operasional perusahaan dengan fokus pada efisiensi dan peningkatan kualitas layanan.',
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
    {
      id: 3,
      name: 'Dimas Prasetyo',
      position: 'CMO',
      image: 'https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1600',
      bio: 'Pakar pemasaran dan pengembangan bisnis dengan jaringan luas di berbagai industri di Indonesia.',
      social: {
        linkedin: '#',
        facebook: '#',
        instagram: '#',
      },
    },
  ];

  return (
    <section className="py-20">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
            Tim Kami
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
            Kenali tim profesional kami yang berdedikasi untuk memberikan layanan terbaik.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="card group overflow-hidden"
            >
              <div className="relative overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy-900/90 to-transparent p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <div className="flex justify-center space-x-4 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <a
                      href={member.social.linkedin}
                      className="text-white hover:text-yellow-500 transition-colors"
                      aria-label="LinkedIn"
                    >
                      <Linkedin size={18} />
                    </a>
                    <a
                      href={member.social.facebook}
                      className="text-white hover:text-yellow-500 transition-colors"
                      aria-label="Facebook"
                    >
                      <Facebook size={18} />
                    </a>
                    <a
                      href={member.social.instagram}
                      className="text-white hover:text-yellow-500 transition-colors"
                      aria-label="Instagram"
                    >
                      <Instagram size={18} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-1 text-navy-900">
                  {member.name}
                </h3>
                <p className="text-primary-600 font-medium mb-3">{member.position}</p>
                <p className="text-gray-600">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;